import { useQuery } from '@tanstack/react-query';

import getPublishStatuses from 'Api/brief-live/getPublishStatuses';

import getPublishStatusesResponse from './model/response/getPublishStatusesResponse';

const useGetPublishStatuses = () => {
  return useQuery({
    queryKey: ['all-publish-statuses'],
    queryFn: async () => {
      const response = await getPublishStatuses();

      const result = getPublishStatusesResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 15 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
};

export default useGetPublishStatuses;
